import { LayoutType, withLayout } from 'hocs/with-layout';
import { withAuth } from 'hocs/auth/with-auth';
import { VaultNew } from './vault-new';

const WrappedPage = withAuth(VaultNew);
const WrappedVaultNewView = withLayout(LayoutType.WithOldNavOnly, WrappedPage);

export { WrappedVaultNewView as VaultNew };
